import { Row } from '@vivaldis/antd-ui'
import { isFuture, isValid, parseISO } from 'date-fns'
import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { useDateFormat } from '@vivaldis/common'
import { EmployeeProfileQuery_employee } from '../../../../typings/EmployeeProfileQuery'
import { Information } from '../../../../../Information'
import { RemainingWorkingHours } from './components/RemainingWorkingHours'

export interface EmployeeProfileProps {
  employee: EmployeeProfileQuery_employee
  onRefreshRemainingHours?: () => Promise<void>
}

export const SuperUserInfo = ({
  employee,
  onRefreshRemainingHours
}: EmployeeProfileProps) => {
  const [t] = useTranslation('web_ui')
  const format = useDateFormat('d MMMM yyyy')

  const isFlexiForbidden = useMemo(() => {
    if (!employee.workProfile?.flexiNotAllowedUntil) {
      return false
    }

    const flexiNotAllowedUntilDate = parseISO(
      employee.workProfile.flexiNotAllowedUntil
    )
    if (!isValid(flexiNotAllowedUntilDate)) {
      return false
    }

    // if future = true -> return true (means flexi is not allowed)
    // if future = false -> return false (means flexi is allowed)

    return isFuture(flexiNotAllowedUntilDate)
  }, [employee.workProfile?.flexiNotAllowedUntil])

  const flexiForbiddenUntil = useMemo(() => {
    if (!employee.workProfile?.flexiNotAllowedUntil) {
      return false
    }

    const flexiNotAllowedUntilDate = parseISO(
      employee?.workProfile?.flexiNotAllowedUntil
    )
    if (!isValid(flexiNotAllowedUntilDate)) {
      return false
    }

    return format(flexiNotAllowedUntilDate)
  }, [employee.workProfile?.flexiNotAllowedUntil, format])

  if (!isFlexiForbidden && (!onRefreshRemainingHours || !employee?.isStudent)) {
    return null
  }

  return (
    <>
      {isFlexiForbidden ? (
        <Information.InformationField
          label={t('employee_profile.flexi_work.label')}
        >
          <Row justify="end">{t('employee_profile.flexi_work.forbidden')}</Row>

          <Row justify="end">
            {t('employee_profile.flexi_work.forbidden_until', {
              date: flexiForbiddenUntil
            })}
          </Row>
        </Information.InformationField>
      ) : null}

      <RemainingWorkingHours
        employee={employee}
        onRefreshRemainingHours={onRefreshRemainingHours}
      />
    </>
  )
}
